import { createFileRoute } from "@tanstack/react-router";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import { PublicHero } from "@/components/public/PublicHero";
import { PublicTiles } from "@/components/public/PublicTiles";
import { PublicProcess } from "@/components/public/PublicProcess";
import { PublicTrustBar } from "@/components/public/PublicTrustBar";
import { PublicMarquee } from "@/components/public/PublicMarquee";

import { AngelikaChat } from "@/components/AngelikaChat";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Energy Prime 360 – Potentiale verstehen. Förderungen nutzen. Sicher entscheiden." },
      {
        name: "description",
        content:
          "Unabhängiges Analyse- und Vergleichsportal für Energie, Sanierung, Fördermittel, Finanzierung und Steuer. Kostenlos, herstellerneutral, alle Faktoren im Blick.",
      },
      { property: "og:title", content: "Energy Prime 360" },
      {
        property: "og:description",
        content: "Unabhängiges Analyse- und Vergleichsportal. Alle Faktoren im Blick. Die beste Entscheidung für Ihr Projekt.",
      },
    ],
    links: [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Urbanist:wght@400;500;600;700;800&family=Epilogue:wght@300;400;500;600&display=swap",
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-white text-navy">
      <SiteNav />
      <main>
        <PublicHero />
        <PublicMarquee />

        <PublicTiles />
        <PublicProcess />
      </main>
      <SiteFooter />
      <AngelikaChat />
    </div>
  );
}
